<mat-menu #devToolsMenu>
  <a mat-menu-item (click)="reload()">
    <mat-icon>refresh</mat-icon>
    Reload
  </a>
  <a mat-menu-item (click)="showInfo = true" [disabled]="showInfo">
    <mat-icon>info</mat-icon>
    Info
  </a>
  <a mat-menu-item (click)="card.primary = false" *ngIf="primary">
    <mat-icon>arrow_forward</mat-icon>
    To Secondary
  </a>
  <a mat-menu-item (click)="card.primary = true" *ngIf="!primary">
    <mat-icon>arrow_back</mat-icon>
    To Primary
  </a>
  <a mat-menu-item (click)="remove()">
    <mat-icon>close</mat-icon>
    Remove
  </a>
</mat-menu>

<div class="row-title" *ngIf="!component || card.placeholder">
  <a class="row-title-link">
    <mat-icon>hourglass_empty</mat-icon>
    <span class="placeholder"></span>
  </a>
</div>
<div class="row-title" *ngIf="component && !card.placeholder">
  <a class="row-title-link" [url]="component.more?.url">
    <ng-container *ngIf="component.icon">
      <mat-icon *ngIf="component.icon.type === 'icon'" [style.color]="component.icon.color ?? 'white'">
        {{component?.icon.name}}
      </mat-icon>
      <img
        *ngIf="component.icon.type === 'image'"
        [src]="component.icon.name"
        >
    </ng-container>
    <span class="title-text cms-content" [innerHTML]="(component?.title ?? card?.title ?? '') | trustHtml"></span>
  </a>
  <div class="spacer"></div>
  <div class="action-buttons" *ngIf="component.more || component.followButton || enableDevTools">
    <tyt-follow-button
      *ngIf="component.followButton"
      [type]="component.followButton.type"
      [id]="component.followButton.id"
      ></tyt-follow-button>
    <a class="more-button" mat-button [target]="component.more.newTab ? '_blank': '_self'" [url]="component.more.url" *ngIf="component.more">
      <mat-icon>{{ component.more.icon ?? 'open_in_new' }}</mat-icon>
      {{ component.more.label ?? 'More' }}
    </a>
    <button mat-icon-button *ngIf="enableDevTools" [matMenuTriggerFor]="devToolsMenu">
      <mat-icon>code</mat-icon>
    </button>
  </div>
</div>

<div class="info" *ngIf="enableDevTools && showInfo">
  <button class="close" mat-icon-button (click)="showInfo = false">
    <mat-icon>close</mat-icon>
  </button>

  <ng-container *ngIf="component">
    <div class="property">
      <label>Class</label>
      {{ component.constructor.name }}
    </div>
    <div class="property">
      <label>Hidden</label>
      {{ component.hidden ? 'Yes' : 'No' }}
    </div>
    <div class="property">
      <label>Title</label>
      <code>{{ component.title }}</code>
    </div>
    <div class="property">
      <label>Icon</label>
      <code>{{ component.icon | json }}</code>
    </div>
    <div class="property">
      <label>More</label>
      <code>{{ component.more | json }}</code>
    </div>
    <div class="property">
      <label>Follow</label>
      <code>{{ component.followButton | json }}</code>
    </div>
  </ng-container>

  <br/>
  <strong>Card</strong>
  <pre>{{ card | json }}</pre>

  <button mat-raised-button (click)="showInfo = false">
    <mat-icon>close</mat-icon>
    Hide Info
  </button>
</div>

<div class="component-container" [class.hidden]="enableDevTools && showInfo">
  <tyt-home-card-component-host
    #componentHost
    [componentClass]="type"
    [card]="card"
    (componentChanged)="component = $event"
    ></tyt-home-card-component-host>
</div>